export const setAppResponsiveZoom = (pathname) => {
	if (pathname.includes("pointofsale")) {
		document.body.classList.add("no-zoom");
	} else {
		document.body.classList.add("responsive-zoom");
	}
};
